import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import { ToastProvider } from "./Components/ui";
import TestTop from "./Pages/TestTop";
import Wizard from "./Pages/Wizard";
import About from "./Pages/About";
import ContactForm from "./Pages/ContactForm";
import BrandProducts from "./Pages/BrandProducts";
import Brands from "./Pages/Brands";

// 診断ページは専用の上部バーを使うので、共通のヘッダー・フッターを出さない
function Shell() {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/wizard");
  return (
    <div className="flex min-h-screen flex-col bg-white">
      {!bare && <Header />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<TestTop />} />
          <Route path="/wizard" element={<Wizard />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/brands/:brandSlug" element={<BrandProducts />} />
        </Routes>
      </main>
      {!bare && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ToastProvider>
        <Shell />
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
